export default "__VITE_ASSET__4a84419f__"